import { checkPwa } from './utils/isPwa';

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (checkPwa()) {
        registerSW(swUrl, config, true);
      } else {
        unregister();
      }
    });
  }
}

function registerSW(swUrl: string, config?: Config, handleUpdates: boolean = false) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      if (handleUpdates) {
        registration.update();
      }

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              if (handleUpdates && config?.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              if (handleUpdates && config?.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Ошибка при регистрации Service Worker:', error);
    });
}

export function updateServiceWorker() {
  if ('serviceWorker' in navigator && checkPwa()) {
    navigator.serviceWorker.ready
      .then(registration => registration.update())
      .catch(error => console.error('Ошибка обновления:', error));
  }
}

export function skipWaiting() {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller && checkPwa()) {
    navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => registration.unregister())
      .catch(error => console.error('Ошибка отмены регистрации:', error));
  }
}